import { useIdle } from '@corets/use-idle';
import { Button } from '@service-victoria/component-library/components/Button';
import Body from '@service-victoria/component-library/components/Text/Body';
import Heading from '@service-victoria/component-library/components/Text/Heading';
import Link from '@service-victoria/component-library/components/Text/Link';
import React, { useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';

import BusinessDetailsSubContent from 'Components/BusinessDetailsSubContent';
import {
  CallToActionContainer,
  ContentContainer
} from 'Components/KioskRegistration/KioskRegistration';
import Page from 'Components/Page';
import { useRegisteredLocations } from 'hooks';
import { Routes } from 'utils/constants';

import { trackEvent } from '../../utils/analytics';
import * as Styled from './styled';

const RegisteredLocation: React.FC = () => {
  const { selectedLocation } = useRegisteredLocations();
  const history = useHistory();

  const isIdle = useIdle({
    // check every 10s
    interval: 10 * 1000,
    // user as idle after 1min
    threshold: 60 * 1000,
    // events that should reset the idle status (default: ["mousemove", "mouseup", "keyup", "focus", "resize"])
    events: ['mouseup', 'touchend', 'keyup', 'focus']
  });

  const navigateToCheckInPage = () => {
    trackEvent({
      action: 'KioskAdmin',
      label: 'returnToCheckIn'
    });
    history.push(Routes.CheckIn);
  };

  const navigateToRegisterPage = () => {
    trackEvent({
      action: 'KioskAdmin',
      label: 'changeDevice'
    });
    history.push(Routes.Register);
  };

  useEffect(() => {
    if (isIdle) {
      navigateToCheckInPage();
      trackEvent({
        label: 'redirectInactiveToCheckin',
        action: 'KioskCheckIn',
        data: {
          locationId: selectedLocation?.locationId ?? ''
        }
      });
    }
    // eslint-disable-next-line
  }, [isIdle]);

  if (!selectedLocation) {
    return <Redirect to={Routes.Register} />;
  }
  return (
    <Page
      banner={{
        title: selectedLocation.businessName,
        content: (
          <BusinessDetailsSubContent
            locationName={selectedLocation.locationName}
            areaName={selectedLocation.areaName}
          />
        )
      }}>
      <Heading.H3 fontWeight={600} data-testid='PageHeding'>
        Current location
      </Heading.H3>
      <ContentContainer>
        <Body fontWeight={600} data-testid='PageBodyLocation'>
          Location: {selectedLocation.locationName}
        </Body>
        {selectedLocation.areaName && (
          <Body fontWeight={600} data-testid='PageBodyAreaName'>
            Area: {selectedLocation.areaName}
          </Body>
        )}
        <Body data-testid='PageBody'>
          You can change this devices location if being used elsewhere.
        </Body>
      </ContentContainer>
      <CallToActionContainer>
        <Button type='button' onClick={navigateToCheckInPage} data-testid='BackToCheckInButton'>
          Back to check-in
        </Button>
        <Button
          buttonType='secondary'
          onClick={navigateToRegisterPage}
          data-testid='ChangeDeviceButton'>
          Change device location
        </Button>
      </CallToActionContainer>
      <Styled.PrivacyContainer>
        <Styled.PrivacyContainerHeaderText data-testid='PrivacyHeader'>
          Important Information
        </Styled.PrivacyContainerHeaderText>
        <div>
          <Link
            href='https://service.vic.gov.au/privacy-and-security'
            target='_blank'
            data-testid='PrivacyLink'>
            Privacy Policy
          </Link>{' '}
          &amp;{' '}
          <Link
            href='https://service.vic.gov.au/terms-of-use'
            target='_blank'
            data-testid='TermsLink'>
            Terms of Use
          </Link>
          .
        </div>
      </Styled.PrivacyContainer>
    </Page>
  );
};

export default RegisteredLocation;
